var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Map',{attrs:{"config":_vm.config,"areaData":_vm.areaData,"renderAreaData":_vm.renderAreaData,"mapType":"社区养老场所","className":"com-baidu-map"}})}
var staticRenderFns = []

export { render, staticRenderFns }